import { Route } from 'react-router';

import { EnsureRoleRoute } from '#bootstrap/utils';
import { ADDONS, PRICE_MODEL } from '#common/constants/addons';
import { USER_ROLES } from '#common/constants';

import type { Addon } from '../types';

function DummyPage() {
  return (<>This is dummy page</>);
}

const addon: Addon = {
  apply: (bootstrap) => {
    bootstrap.admin = bootstrap.admin.concat([
      <Route
        key="route-admin-dummy"
        path="dummy"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <DummyPage />
          </EnsureRoleRoute>
        )}
      />,
    ]);

    bootstrap.panel = bootstrap.panel.concat([{
      label: 'Dummy Addon',
      link: '/management/dummy',
      linkAlias: ['management/dummy'],
    }]);
  },

  info: {
    id: ADDONS.DUMMY,
    available: true,
    name: 'Dummy Addon',
    version: '0.1',
    descriptionText: 'Dummy Addon Description',
    descriptionComponent: <div>Dummy Description</div>,
    priceModel: PRICE_MODEL.FREE,
    // price: 99.99,
  },
};

export default addon;
